import React, { useState } from "react";
import { getImage } from "../../../../../../utils/getImages";

const TabPreview = ({ activetab, cardData }) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    if (!cardData) {
        return (
            <div
                style={{
                    textAlign: "center",
                    padding: "40px",
                    border: "1px dashed #ccc",
                    borderRadius: "10px",
                    color: "#777",
                }}
            >
                No preview data available
            </div>
        );
    }

    const getLangText = (item, key) => {
        if (!item) return "";
        switch (activetab) {
            case "simplified_chinese":
                return item[`simplified_chinese_${key}`] || "";
            case "treditonal_chinese":
                return item[`traditional_chinese_${key}`] || "";
            case "arabic":
                return item[`arabic_${key}`] || "";
            case "bahasa":
                return item[`bahasa_${key}`] || "";
            default:
                return item[key] || "";
        }
    };

    const level1Tabs = cardData?.dataArray || [];
    const activeTab = level1Tabs[activeTabIndex];
    const level2Cards = activeTab?.dataArray || [];

    return (
        <div
            style={{
                padding: "40px 20px",
                background: "#fff",
                borderRadius: "10px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    borderBottom: "2px solid #eee",
                    marginBottom: "30px",
                    gap: "15px",
                }}
            >
                {level1Tabs.map((tab, i) => (
                    <button
                        key={i}
                        onClick={() => setActiveTabIndex(i)}
                        style={{
                            background: "none",
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            padding: "10px 18px",
                            fontSize: "16px",
                            // fontWeight: i === activeTabIndex ? "600" : "400",
                            color: i === activeTabIndex ? "#0b2b6b" : "#666",
                            borderBottom:
                                i === activeTabIndex
                                    ? "1px solid #0b2b6b"
                                    : "1px solid transparent",
                            transition: "all 0.3s ease",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        {getLangText(tab, "title")}
                    </button>
                ))}
            </div>

            {activeTab && (
                <div style={{ textAlign: "center" }}>
                    {activeTab?.description && (
                        <div
                            style={{
                                margin: "0 auto 40px",
                                color: "#666",
                                fontFamily: "sans-serif",
                                // textTransform: "uppercase",
                                fontSize: "16px",
                                lineHeight: "1.7",
                            }}
                            dangerouslySetInnerHTML={{
                                __html: getLangText(activeTab, "description"),
                            }}
                        />
                    )}

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                            gap: "30px",
                            justifyItems: "center",
                        }}
                    >
                        {level2Cards.map((card, index) => (
                            <div
                                key={index}
                                style={{
                                    // maxWidth: "300px",
                                    textAlign: "center",
                                }}
                            >
                                {card?.image && (
                                    <img
                                        src={getImage(card.image)}
                                        alt={getLangText(card, "title")}
                                        style={{
                                            width: "130px",
                                            height: "130px",
                                            objectFit: "contain",
                                            marginBottom: "20px",
                                            // filter:
                                            //     "invert(18%) sepia(79%) saturate(1500%) hue-rotate(190deg) brightness(95%)",
                                        }}
                                    />
                                )}

                                <h4
                                    style={{
                                        fontSize: "16px",
                                        color: "#444",
                                        fontWeight: "500",
                                        marginBottom: "8px",
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: getLangText(card, "title"),
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: "15px",
                                        color: "#666",
                                        lineHeight: "1.6",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: getLangText(card, "description"),
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TabPreview;
